<template>
	<div class="manage-view">
		<div class="container-fluid p-0" style="background-color: none !important;">
			<b-tabs card class="nonobg">
				<b-tab title="Aktivita" class="nobg">
					<div class="row px-2" style="color: gray;">
						<h3> Aktivita uživatelů: </h3>
					</div>

					<div class="row px-2">

						<div class="list-group my-list col-xs col-lg-8" v-if="! activityFetching">
							<div class="list-group-item" v-for="l of logs" :key="l.id">
								<span v-if="typeOfLog(l.msg) === 'vyhledavani'" class="badge badge-success" style="width: 90px"> vyhledávání </span>
								<span v-else class="badge badge-warning" style="width: 90px"> zobrazení </span>
								<span style="font-weight: bold; color: gray;"> {{ formatTime(l.timestamp_added) }}:</span> {{ l.msg }} <span v-if="l.duration" style="color: gray; font-size: 14px;"> ({{ l.duration / 1000 }} sekund) </span>
							</div>
						</div>
						<div v-else class="my-list col-xs col-lg-8 " style="text-align: center;">
							<b-spinner style="margin-top: 200px;" label="Spinning"></b-spinner>
							 Načítám
						</div>

					</div>
					<div class="row px-2 mt-4" style="color: gray;">
						<h3> Aktivita upgrade kontrol: </h3>
					</div>
					<div class="row px-2">
						<div class="list-group my-list my-list-checks col-xs col-lg-8" v-if="! upgradeActivityFetching">
							<div class="list-group-item" v-for="l of upgradeLogs" :key="l.date">
								<span v-if="l.type === 'check'" >
									<span class="badge badge-success" style="width: 80px"> kontrola </span>
									<span style="font-weight: bold; color: gray;"> {{ formatTime(l.date) }}: </span>
									Zkontrolováno sledování:
									{{ l.data.first_name}} {{ l.data.last_name}}
									<span class="badge badge-info">{{l.username}} </span>
									<span style="color: gray; font-size: 14px;"> (Sledovani ID: {{ l.sledovani_id }}) </span>
								</span>
								<span v-else>
									<span class="badge badge-warning" style="width: 80px"> mail </span>

									<span style="font-weight: bold; color: gray;"> {{ formatTime(l.date) }}:</span>
									Odeslán email {{ l.type === 'wttx' ? 'pro kontrolu ' : 'o změně ' }}
									<span style="font-weight: bold"> {{ l.type }} </span>
									<span style="color: gray; font-size: 14px;"> (Sledovani ID: {{ l.sledovani_id}}{{ l.removed && ' - Sledování odstraněno.' }}) </span>
								</span>
							</div>
						</div>
						<div v-else class="my-list col-xs col-lg-8 " style="text-align: center;">
							<b-spinner style="margin-top: 200px;" label="Spinning"></b-spinner>
							 Načítám
						</div>
					</div>

					<div class="row px-2 mt-4" style="color: gray;">
						<h3> Api dotazy: </h3>
					</div>
					<div class="row px-2">
						<div class="list-group my-list my-list-checks col-xs col-lg-8" v-if="! apiActivityFetching">
							<div class="list-group-item" v-for="l of apiActivityLogs" :key="l.sent_at">
								<span >
									<span style="font-weight: bold; color: gray;"> {{ formatTime(l.sent_at) }}: </span>
									<span class="badge badge-success" style="font-size: 15px; line-height: 16px;"> {{ l.ip }} </span>
									Vráceny produkty pro RUIAN: {{ l.ruian }}. Priorita:
									<span class="badge badge-info">{{ l.priority }} </span>
								</span>
							</div>
						</div>
						<div v-else class="my-list col-xs col-lg-8 " style="text-align: center;">
							<b-spinner style="margin-top: 200px;" label="Spinning"></b-spinner>
							 Načítám
						</div>
					</div>
				</b-tab>

				<b-tab title="Aktivní uživatelé" class="nobg">
					<div class="list-group col-xs col-lg-4" v-if="! activityFetching">
							<div class="list-group-item my-list-item" v-for="l of userActivity" :key="l.user">
								<span class="activity-bubble" :style="{ backgroundColor: checkActivity(l.last_activity)}"></span>
								<span class="activity-text"> {{l.user}} </span>
							</div>
						</div>
				</b-tab>

				<b-tab no-body title="Statistiky" class="nobg">
					<div class="row pt-4 mx-2">
						<div class="col" style="display: flex; flex-direction: row;">
							<span style="line-height: 35px; margin-top: 10px; margin-right: 10px;"> Od: </span>
							<datepicker class="mid-barber-input date-picker"
								placeholder="Datum od"
								format="dd.MM. yyyy"
								v-model="dateFrom"
							></datepicker>
						</div>
					</div>
					<div class="row pt-2 mx-2">
						<div class="col" style="display: flex; flex-direction: row;">
							<span style="line-height: 35px; margin-top: 10px; margin-right: 10px;"> Do: </span>

							<datepicker class="mid-barber-input date-picker"
								placeholder="Datum do"
								format="dd.MM. yyyy"
								v-model="dateTo"
								id="dateToPicker"
							></datepicker>

						</div>
					</div>
					<div class="row px-0 mx-0 ml-4 mt-4" style="color: gray;">
						<h3> Počet vyhledávání/den </h3>
					</div>
					<div class="row px-0 mx-0">
						<div class="col-xs col-md-10" v-if="displayStat">
							<RandomChart :chartData="chartData" :chartLabels="chartLabels" style="height: 300px; width: 100%;" v-if="displayStat" />
						</div>
					</div>
					<div class="row px-0 mx-0 ml-4 mt-4" style="color: gray;">
						<h3> Kontroly čekáme na upgrade </h3>
					</div>
				</b-tab>
				<b-tab no-body title="Aktualizace" class="nobg">
					<div class="row pt-4 mx-2">
						<div class="col">
							<div class="d-none d-md-block h3"> Akutalizace adresní databáze </div>
							<div class="d-xs-block d-md-none h5"> Akutalizace adresní databáze </div>
						</div>
					</div>
					<div class="row mx-2">
						<div class="col">
							Konec minuleho mesice ve formatu: YYYYMMDD
						</div>
					</div>
					<div class="row mx-2 mt-2">
						<div class="col col-md-2">
							<input class="form-control" v-model="kodZalohy" placeholder="20191130" />
						</div>
						<div class="col col-md-1">
							<button class="btn btn-success download-button" @click="downloadIt()"> Download </button>
						</div>
					</div>
					<div class="row mx-2 mt-4">
						<div class="col col-md-2">
							<span class="h5" style="line-height: 30px;"> Downloaded </span>
						</div>
						<div class="col col-md-2">
							<button v-if="! downloadedShowing" @click="downloadedShowing = ! downloadedShowing" class="btn btn-light"> ▼ </button>
							<button v-else @click="downloadedShowing = ! downloadedShowing" class="btn btn-light"> X </button>
						</div>
					</div>
					<div class="row mx-4 mt-2" v-if="downloadedShowing" >
						<div v-if="! downloading" class="list-group my-list-two col-xs col-lg-4 mt-lg-4 pr-0">
							<div class="list-group-item my-item pl-1 mr-0" v-for="(d, index) of fetchDownloaded" :key="index">
								<span v-if="isUnzipped(d)" class="badge badge-success "> unzipped </span>
								<span v-else class="badge badge-warning "> zipped </span>
								<button v-if="! isUnzipped(d)" class="btn btn-sm btn-secondary" @click="unzip(d)"> unzip </button>
								<span> {{ d }} </span>
							</div>
						</div>
						<div v-else class="my-list-two col-xs col-lg-4 mt-lg-4">
							<b-spinner style="margin-top: 40px;" label="Spinning"></b-spinner>
							 Downloading
						</div>
					</div>

					<div class="row mx-2 mt-4">
						<div class="col col-md-2">
							<span class="h5" style="line-height: 30px;"> Unzipped </span>
						</div>
						<div class="col col-md-2">
							<button v-if="! unzippedShowing" @click="unzippedShowing = ! unzippedShowing" class="btn btn-light"> ▼ </button>
							<button v-else @click="unzippedShowing = ! unzippedShowing" class="btn btn-light"> X </button>
						</div>
					</div>
					<div class="row mx-4 mt-2" v-if="unzippedShowing">
						<div v-if="! unzipping" class="list-group my-list-two col-xs col-lg-4 mt-lg-4 pr-0">
							<div class="list-group-item my-item pl-1 mr-0" v-for="(d, index) of techUnzipped" :key="index">
								{{ d.name }} ({{ d.size }})
								<button @click="nahrat(d.name)" class="btn btn-secondary"> nahrat </button>
							</div>
						</div>
						<div v-else class="my-list-two col-xs col-lg-4 mt-lg-4">
							<b-spinner style="margin-top: 40px;" label="Spinning"></b-spinner>
							 Unzipping
						</div>
					</div>
					<div class="row mt-5 mx-2">
						<div class="col">
							<button @click="checkStatus" class="btn btn-danger"> status refresh </button>
						</div>
					</div>
					<div class="row mt-4 mx-2 mb-4" v-if="nahravam">
						<div class="col col-md-1">
							<b-spinner  label="Spinning"></b-spinner>
								{{ status }} %
						</div>
					</div>
					<div v-else class="row mt-2 mx-2 mb-4">
						<div class="col col-md-1">
							Momentalne nenahravam
						</div>
					</div>
				</b-tab>
				<b-tab title="Tickety" class="nobg">
					<h3 style="color: gray;"> Tickety: </h3>
					<div class="row px-2" >
						<div class="list-group my-list col-xs col-lg-8" v-if="! fetchingTickets">
							<div class="list-group-item ticket"  v-for="ticket of problemTickets" :key="ticket.id" @click="selectTicket(ticket)" :class="{ 'selected-ticket': selectedTicket !== null && ticket.id === selectedTicket.id }">
								<span class="badge" :class="{ 'badge-success': ticket.resolved, 'badge-warning': !ticket.resolved }" style="width: 90px"> {{ ticket.resolved ? 'Vyřešeno' : 'Nevyřešeno' }} </span>
								<span class="badge badge-info" > {{ ticket.user }} </span>
								<span style="font-weight: bold; color: gray;"> {{ formatTime(ticket.created_at) }}:</span> {{ ticket.text }}
							</div>
						</div>
						<div class="col-lg-2" v-if="selectedTicket">
							<button v-if="! selectedTicket.resolved" class="btn btn-success" @click="setTicketAsDone(selectedTicket.id)"> Hotovo </button>
							<button v-else class="btn btn-warning" @click="setTicketAsNotDone(selectedTicket.id)"> Znovu otevřít </button>
							<button class="btn btn-danger" @click="deleteTicket(selectedTicket.id)"> Smazat </button>
						</div>
					</div>
					<!-- <div v-for="ticket of problemTickets" class="row px-2">
						{{ ticket }}
					</div> -->

				</b-tab>
			</b-tabs>
		</div>
	</div>
</template>

<script>
import AdditionsService from '@/services/AdditionsService'
import Datepicker from 'vuejs-datepicker'
import RandomChart from '@/components/charts/RandomChart'
const moment = require('moment')

export default {
	name: 'ManageView',

	components: {
		Datepicker,
		RandomChart,
	},

    data() {
        return {
			kodZalohy: 20191130,
			fetchDownloaded: [],
			techUnzipped: {},
			status: 0,
			downloading: false,
			unzipping: false,
			logs: [],
			downloadedShowing: false,
			unzippedShowing: false,
			nahravam: false,
			dateFrom: null,
			dateTo: new Date(),
			chartData: {},
			chartLabels: [],
			upgradeChartData: {},
			upgradeChartLabels: [],
			options: {
				responsive: true,
				maintainAspectRatio: false
			},
			displayStat: false,
			displayUpgradeStat: false,
			activityFetching: false,
			upgradeActivityFetching: false,
			upgradeLogs: [],
			userActivity: [],
			problemTickets: [],
			selectedTicket: null,
			fetchingTickets: true,
			apiActivityFetching: false,
			apiActivityLogs: [],
        }
	},

	async mounted () {
		await this.fetchDownloadedFun()
		this.activityFetching = true
		await this.fetchUnzippedFun()
		await this.checkStatus()
		this.fetchActivityLogs()
		this.fetchApiActivityLogs()
		this.fetchUpgradeActivityLogs()
		this.fetchUserRecentActivity()
		this.fetchTickets()

		let dateFrom = new Date()
		const pastDate = dateFrom.getDate() - 7
		dateFrom.setDate(pastDate)
		this.dateFrom = dateFrom

		await this.fetchChartData()
		this.$nextTick(() => {
			this.displayStat = true
		})

		await this.fetchUpgradeChartData()
		this.$nextTick(() => {
			this.displayUpgradeStat = true
		})
	},

    methods: {
		formatTime (timestamp) {
			const newDate = new Date(timestamp)
			newDate.setHours(newDate.getHours() + 2)
            const timeFormattedYear = newDate.getUTCFullYear()
            const timeFormattedMonth = newDate.getUTCMonth() + 1
            const timeFormattedDay = newDate.getUTCDate()

            const timeFormattedHour = newDate.getUTCHours()
            const timeFormattedMinute = newDate.getUTCMinutes()
            const timeFormattedSecond = newDate.getUTCSeconds()

            return timeFormattedDay + '.' + timeFormattedMonth + '.' + timeFormattedYear + ' - ' + timeFormattedHour + ':' + (timeFormattedMinute > 9 ? timeFormattedMinute : '0' + timeFormattedMinute) + ':' + (timeFormattedSecond > 9 ? timeFormattedSecond : '0' + timeFormattedSecond)
		},

		async fetchUserRecentActivity () {
			const data = await AdditionsService.fetchRecentUserActivity()
			this.userActivity = data.data.activity
		},

		checkActivity (time) {
			const activityTime = moment(time)
			const beforeTwo = moment().subtract(2, 'minutes')
			const beforeFifteen = moment().subtract(15, 'minutes')
			if (activityTime.isAfter(beforeFifteen)) {
				if (activityTime.isAfter(beforeTwo)) {
					return 'green'
				} else {
					return 'orange'
				}
			} else {
				return 'red'
			}
		},

		typeOfLog (msg) {
			const t = msg.split('')
			return t[t.length - 1] === ')' ? 'zobrazeni' : 'vyhledavani'
		},

		isUnzipped (item) {
			for (const o of this.techUnzipped) {
				if (o.name === item.split('.')[0]) {
					return true
				}
			}
			return false
		},

		getRandomInt () {
			return Math.floor(Math.random() * (50 - 5 + 1)) + 5
		},

		async fetchChartData () {
			const from = moment(this.dateFrom).format('YYYY-MM-DD')
			const to = moment(this.dateTo).format('YYYY-MM-DD')
			const data = await AdditionsService.fetchChartData(from, to)
			this.chartData = data.data.chartData
			this.chartLabels = data.data.chartLabels
		},

		async fetchUpgradeChartData () {
			const from = moment(this.dateFrom).format('YYYY-MM-DD')
			const to = moment(this.dateTo).format('YYYY-MM-DD')

			const data = await AdditionsService.fetchUpgradeChartData(from, to)
		},

		formatMsg (msg) {
			const newMsg = msg.split(' ')
			const test = newMsg[0] + ' <span class="user-pretty">' + newMsg[1] + '</span> ' + newMsg.slice(2).join(' ')
			return test
		},

        async downloadIt () {
			this.downloading = true
			const downloaded = await AdditionsService.downloadZalohuDb(this.kodZalohy)
			this.downloading = false
			await this.fetchDownloadedFun()

		},

		async unzip (d) {
			this.unzipping = true
			const unzipped = await AdditionsService.unzipZalohuDb(d)
			await this.fetchUnzippedFun()
			this.unzipping = false
		},

		async fetchDownloadedFun () {
			const fetchDownloaded = await AdditionsService.fetchDownloadedZipped()
			this.fetchDownloaded = fetchDownloaded.data.data
			this.fetchDownloaded = this.fetchDownloaded.filter(e => { return e !== '.gitkeep' })
		},

		async fetchUnzippedFun () {
			const fetchUnzipped = await AdditionsService.fetchDownloadedUnzipped()
			this.techUnzipped = fetchUnzipped.data.data
			this.techUnzipped = this.techUnzipped.filter(e => { return e.name !== '.gitkeep' })
		},

		async nahrat (d) {
			this.nahravam = true
			const nahrano = await AdditionsService.nahrajDatabazi(d)
			this.checkStatus()
		},

		async checkStatus (d) {
			const status = await AdditionsService.checkStatus()
			this.status = status.data.data
			if (parseInt(this.status) === 100) {
				this.nahravam = false
			} else {
				this.nahravam = true
			}
			if (this.nahravam) {
				setTimeout(function () { this.checkStatus() }.bind(this), 5000)
			}
		},

		async fetchActivityLogs () {
			this.activityFetching = true
			const logs = await AdditionsService.fetchActivityLogs()
			this.logs = logs.data.data
			this.activityFetching = false
		},

		async fetchApiActivityLogs () {
			this.apiActivityFetching = true
			console.log('fetch api activity logs');
			const logs = await AdditionsService.fetchApiActivityLogs()
			console.log(logs);
			this.apiActivityLogs = logs.data.data
			this.apiActivityFetching = false
		},

		async fetchUpgradeActivityLogs () {
			this.upgradeActivityFetching = true
			const upgradeLogs = await AdditionsService.fetchUpgradeActivityLogs()
			this.upgradeLogs = upgradeLogs.data.data
			this.upgradeActivityFetching = false
	   	},

		async fetchTickets () {
			this.fetchingTickets = true
			const ticketsFetch = await AdditionsService.fetchTickets()
			this.problemTickets = ticketsFetch.data.data
			this.fetchingTickets = false
		},

		selectTicket (ticket) {
			this.selectedTicket = ticket
		},

		async setTicketAsDone (id) {
			await AdditionsService.ticketAction(1, id)
			this.selectedTicket.resolved = true
			this.fetchTickets()
		},

		async setTicketAsNotDone (id) {
			await AdditionsService.ticketAction(2, id)
			this.selectedTicket.resolved = false
			this.fetchTickets()
		},

		async deleteTicket (id) {
			await AdditionsService.ticketAction(3, id)
			this.selectedTicket = null
			this.fetchTickets()
		}
	},

	watch: {
		dateFrom (to) {
			if (this.displayStat) {
				this.fetchChartData()
			}

			if (this.displayUpgradeStat) {
				this.fetchUpgradeChartData()
			}
		},

		dateTo (to) {
			if (this.displayStat) {
				this.fetchChartData()
			}

			if (this.displayUpgradeStat) {
				this.fetchUpgradeChartData()
			}
		}
	}
}
</script>

<style lang="stylus" scoped>
.nonobg
	background-color #e0ecff
	text-decoration none
	color black

.nonobg a
	text-decoration none

.my-list
	max-height 75vh
	min-height 75vh
	overflow-y scroll
	background-color white
	padding 0px

.my-list-two
	min-height 300px
	max-height 300px
	overflow-y scroll
	background-color white

// .my-list-three

.mid-barber-input
	margin-top 12px
	border-radius 6px
	height 38px
	width 200px

.activity-bubble
	width 10px
	height 10px
	display block
	border-radius 25px
	margin-top 8px

.activity-text
	margin-left 10px

.my-list-item
	display flex
	padding 10px

.chart-hold
	height 200px
	width 100%

.logs-title
	font-size 28px
	font-weight bold
	margin-top 20px
	margin-bottom 20px
	margin-left 10px

.downloading
	color red
	font-weight bold

.manage-view
    display flex
	text-align left
	min-height 100vh
	background-color #e0ecff

.manage-view-zero
	border 3px solid #4CA5F9
    border-radius 20px
	padding 20px
	display flex
	flex-direction column
	max-height 400px
	overflow-y scroll

.manage-view-first
	border 3px solid #4CA5F9
    border-radius 20px
	padding 20px
	display flex
	flex-direction column

.manage-view-second
	padding-left 20px
	padding-bottom 20px

.manage-view-third
	padding-left 20px
	padding-bottom 20px

.manage-view-fourth
	padding-left 20px
	padding-bottom 20px
	margin-top 10px
	border 3px solid #4CA5F9
    border-radius 20px
	padding-top 20px

.manage-view-fifth
	padding-left 20px
	padding-bottom 20px
	margin-top 10px
	border 3px solid #4CA5F9
    border-radius 20px
	padding-top 20px

.for-margin
	margin-top 10px

.format-input
	width 200px
	height 40px
	padding-left 20px
	margin-top 10px

.status-number
	font-size 24px

.status-button
	width 200px
	height 50px
	margin-left 20px
	margin-top 20px

.ticket
	cursor pointer

.selected-ticket
	background-color #5cc3ff
	color white

</style>



// WEBPACK FOOTER //
// src/views/ManageView.vue